import React from 'react';
import SectionHeading from './SectionHeading';
import { audiences } from '../data/content';

function Audience() {
  return (
    <section className="section light">
      <div className="container">
        <div className="section-content-after-image">
          <SectionHeading eyebrow="Built for resale">
            Who this is for
          </SectionHeading>
          <div className="audience-grid">
            {audiences.map(([title, description]) => (
              <article className="audience-card" key={title}>
                <h3>{title}</h3>
                <p>{description}</p>
              </article>
            ))}
          </div>
          <aside className="not-for">
            <h3>Who this isn't for</h3>
            <p>
              If you want to list it unedited tonight, this isn't the right buy
              — the licence requires you to change it before you sell it.
            </p>
            <p>
              If you want video, there is none here. Documents, decks and
              guides only.
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default Audience;